import { ExcelTemplateType, LanguageType } from './enum.model';

export class ExportBuildingsModel {
  municipalityId: string;
  exportType: ExcelTemplateType;
  municipalityName: string;
  language: LanguageType;

  constructor(
    municipalityId: string,
    type: ExcelTemplateType,
    municipalityName: string,
    language: LanguageType
  ) {
    this.municipalityId = municipalityId;
    this.exportType = type;
    this.municipalityName = municipalityName;
    this.language = language;
  }
}
